import { updateCustomerById } from "../../../../app/api/updateCustomerById";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { showNotification } from "../../../../Services/notificationService";
import { invalidateUserCaches } from "../invalidateUserCaches";
interface SavePersonalInfoParams {
    values: {
        email: string;
        firstName: string;
        lastName: string;
        birthdate: any;
        phoneNumber: string;
        mobileCode: string;
        gender: string;
        countryCode: string;
        preferredLanguage?: string;
        title: string;
        //Invoice Values
        companyName?: string;
        trn?: string;
        address1?: string;
        address2?: string;
        city?: string;
        countryBilling?: string
    };
    customerId: string;
    invoiceFlag?: boolean;
}

export class SavePersonalInfoAction extends BaseAction<void, SavePersonalInfoParams> {
    override async run(): Promise<void> {
        try {
            const { values, customerId, invoiceFlag } = this.params!;

            if (!customerId) {
                console.error("Customer ID not found.");
                showNotification("error", getTranslatedMessage("errorUpdatingCustomerInformation"), "");
                return;
            }

            const payload: any = {
                email: values.email,
                firstName: values.firstName,
                lastName: values.lastName,
                birthdate: values.birthdate?.format("YYYY-MM-DD"),
                phoneNumber: values.phoneNumber != ""
                    ? `+${values.mobileCode}${values.phoneNumber}`
                    : "",
                gender: values.gender,
                countryCode: values.countryCode,
                preferredLanguage: values.preferredLanguage,
                title: values.title,
            };

            if (invoiceFlag) {
                payload.invoicingAddress = {
                    name: values.companyName,
                    trn: values.trn,
                    street: values.address1,
                    complement: values.address2,
                    city: values.city,
                    countryCode: values.countryBilling
                };
            }

            const userDetails = await updateCustomerById(customerId, payload);
            updateRecoilState("userDataAtom", userDetails.answer);
            invalidateUserCaches();
            showNotification("success", getTranslatedMessage("personalInformationUpdatedSuccessfully"), "");
            updateRecoilState("isPersonalInfoModifiedAtom", false);
        } catch (error) {
            console.error("Error updating customer information:", error);
            showNotification("error", getTranslatedMessage("errorUpdatingCustomerInformation"), "");
        }
    }
}

export const savePersonalInfoAction = new SavePersonalInfoAction();